import Ds18b20Diagram from "../../../../docs/_images/hw_ff_ds18b20.png";
import Ds18b20Schematics from "../../../../docs/_images/hw_ff_ds18b20_schem.png";
import * as React from 'react';
export default {
  Ds18b20Diagram,
  Ds18b20Schematics,
  React
};